import React from "react"
import Modal from "react-modal"
import { OrangeButton } from "../../common"
import PendingBtn from "../../common/PendingSuccessFailBtn/PendingBtn"
import wardrobe from "../../../assets/images/wardrobe.svg"
import "./style.css"

const WarningInfoModal = ({
  show,
  title,
  text,
  onModalCloseClick,
  dirRtl,
  btnText,
  icon,
  moreThanOneOrder,
  isLoading,
}) => {
  if (!show) {
    return <noscript />
  }

  let iconSrc = ""
  if (icon) {
    iconSrc = require(`../../../assets/images/${icon}.png`)
  }

  const onOuterCkick = isLoading
    ? () => {
        console.log("WarningInfoModal      ## outer click  ##")
      }
    : onModalCloseClick

  return (
    <Modal
      isOpen={show}
      onRequestClose={onOuterCkick}
      className="react-modal-content"
      overlayClassName="modal-overlay"
      onClick={(e) => {
        console.log("Modal CLECKED")
        console.log(e)
      }}
    >
      {moreThanOneOrder ? (
        <img src={wardrobe} alt="aron" className="wardrobe" />
      ) : (
        <div className="orange-circle">
          <div className="orange-stick"></div>
          <div className="orange-dot"></div>
        </div>
      )}
      <div className="ooalo-label-extra-class" dir={dirRtl ? "rtl" : "ltr"}>
        {newlineText(title)}
      </div>
      <div
        className="ooalo-label-extra-class ooalo-label-extra-class2"
        dir={dirRtl ? "rtl" : "ltr"}
      >
        {text}
      </div>
      {isLoading ? (
        <PendingBtn />
      ) : (
        <OrangeButton onClick={() => onModalCloseClick()}>
          {btnText}
        </OrangeButton>
      )}
    </Modal>
  )
}

const newlineText = (text) => {
  if (text === undefined || text === null || text.length <= 0) {
    return text
  }
  return text.split("\n").map((str) => <p>{str}</p>)
}
export default WarningInfoModal
